import {
  useEnvironment,
  useExperiments,
  useSettingsEnvironment,
} from '@wix/yoshi-flow-editor';
import { IChallengeStylesVars } from '../components/ChallengesPage/stylesParams';
import { IChallengeStylesVars as IChallengeStylesVarsParticipant } from '../components/ParticipantPage/stylesParams';
import { IChallengeListStylesVars } from '../components/ChallengesList/stylesParams';
import { debug } from '../utils/queryString';

export type CSSVars =
  | IChallengeStylesVars
  | IChallengeStylesVarsParticipant
  | IChallengeListStylesVars;

export function formatVars(displayVar: CSSVars | CSSVars[]) {
  const vars = [].concat(displayVar);
  const fallbacks = vars.map((f) => `var(${f}`);
  const closingParens = new Array(vars.length).fill(')').join('');

  return fallbacks.join(', ') + closingParens;
}

export function useCSSPBStyle() {
  const { experiments } = useExperiments();
  const { isCssPerBreakpoint } = useEnvironment();
  const cssPBEnabled =
    experiments.enabled('specs.programs.OOIStyleBP') && isCssPerBreakpoint;

  return function ({ displayVar }: { displayVar: CSSVars | CSSVars[] }) {
    const display = formatVars(displayVar);
    return cssPBEnabled ? { display } : undefined;
  };
}

export function useCSSPBEnabled() {
  const { experiments } = useExperiments();
  const cssPBEnabled = experiments.enabled('specs.programs.OOIStyleBP');
  const { isCssPerBreakpoint } = useEnvironment();

  return cssPBEnabled && isCssPerBreakpoint;
}

export function useSettingsCSSPBEnabled() {
  const { experiments } = useExperiments();
  const cssPBEnabled = experiments.enabled('specs.programs.OOIStyleBP');
  const { isCssPerBreakpoint } = useSettingsEnvironment();
  debug('useSettingsCSSPBEnabled', cssPBEnabled, isCssPerBreakpoint);

  return cssPBEnabled && isCssPerBreakpoint;
}

export function useHeaderGridEnabled(force = false) {
  const { isCssPerBreakpoint } = useEnvironment();
  const { experiments } = useExperiments();
  const gridEnabled =
    !force && experiments.enabled('specs.programs.VisitorHeaderGrid');

  return gridEnabled && isCssPerBreakpoint;
}

export function useSettingsHeaderGridEnabled(force = false) {
  const { isCssPerBreakpoint } = useSettingsEnvironment();
  const { experiments } = useExperiments();
  const gridEnabled =
    !force && experiments.enabled('specs.programs.VisitorHeaderGrid');

  return gridEnabled && isCssPerBreakpoint;
}
